/* eslint-disable */
import {
  Grid,
  Typography,
  Paper,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  ToggleButton,
  ToggleButtonGroup,
  TextField,
  Button,
  Box,
  Fab,
  Tooltip,
  IconButton,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import ZoomInOutlinedIcon from "@mui/icons-material/ZoomInOutlined";
import CleaningServicesIcon from "@mui/icons-material/CleaningServices";
import AddCircleOutlineOutlinedIcon from '@mui/icons-material/AddCircleOutlineOutlined';
import RemoveCircleOutlineIcon from "@mui/icons-material/RemoveCircleOutline";
import CancelIcon from "@mui/icons-material/Cancel";
import SaveIcon from "@mui/icons-material/Save";
import { DataGrid } from "@mui/x-data-grid";
import { useNavigate, useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import Message from "../../../project/utils/Message";
import { getCobranza } from "../../../project/services/CobranzaService";
import { saveFactura } from "../../../project/services/FacturaService";
import { getClienteByDocument } from "../../../project/services/ClienteService";
import { getPersonaJuridicaByCuit } from "../../../project/services/PersonaJuridicaService";
import { getCacheData } from "../../services/CacheService";
import { isPositiveInteger, roundNumber } from "../../../project/utils/utils";
import BuscarClienteDialog from "../gestion-atencion/BuscarClienteDialog";
import BuscarPersonaJuridicaDialog from "../persona-juridica/BuscarPersonaJuridicaDialog";
import settings from "../../../configs/settings";
import { v4 as uuidv4 } from "uuid";
import WaitingDialog from "../../utils/WaitingDialog";

const initialState = {
  tipoComprobanteFiscal: "",
  condicionFrenteIva: "",
  idCliente: "",
  tipoDocumento: "",
  numeroDocumento: "",
  numeroCuitCuil: "",
  nombre: "",
  apellido: "",
  idPersonaJuridica: "",
  razonSocial: "",
};

const rowItemInitialState = {
  idItem: "",
  codigoItem: "",
  descripcionItem: "",
  cantidadItem: 1,
  puvItem: 0,
  puvItemInicial: 0,
  tasaIva: 0,
  ivaItem: 0,
  totalItem: 0,
};

const pieFacturaInitialState = {
  cancelatoria: false,
  subTotalItems: 0,
  totalDescuentos: 0,
  totalRecargos: 0,
  totalCobrosACuenta: 0,
  totalNoFacturable: 0,
  subTotalFactura: 0,
  ivaFactura: 0,
  totalFactura: 0,
};
//
// #############################################################################
//
const Factura = () => {
  const params = useParams();
  const navigate = useNavigate();
  const idCobranza = params.idCobranza;
  const [itemData, setItemData] = useState(initialState);
  const [condicionesFrenteIva, setCondicionesFrenteIva] = useState([]);
  const [condicionesFrenteIvaFiltered, setCondicionesFrenteIvaFiltered] = useState([]);
  const [condicionFrenteIvaSelected, setCondicionFrenteIvaSelected] = useState("");
  const [tiposComprobantesFiscales, setTiposComprobantesFiscales] = useState([]);
  const [tipoComprobanteFiscalSelected, setTipoComprobanteFiscalSelected] = useState("");
  const [consumidorFinalMonotributoComprobantePara, setConsumidorFinalMonotributoComprobantePara] =
    useState("cliente-ga");
  const [clientesGAs, setClientesGAs] = useState([]);
  const [tiposDocumentos, setTiposDocumentos] = useState([]);
  const [isDoingSomething, setIsDoingSomething] = useState(false);
  const [showMessage, setShowMessage] = useState(false);
  const [message, setMessage] = useState({});
  const [openDialogBuscarCliente, setOpenDialogBuscarCliente] = useState(false);
  const [disableTipoNumeroDocumento, setDisableTipoNumeroDocumento] = useState(false);
  const [disableBuscarClienteButton, setDisableBuscarClienteButton] = useState(false);
  const [disableBuscarClientesButton, setDisableBuscarClientesButton] = useState(false);
  const [openDialogBuscarPersonaJuridica, setOpenDialogBuscarPersonaJuridica] = useState(false);
  const [disableNumeroCuit, setDisableNumeroCuit] = useState(false);
  const [disableBuscarPersonaJuridicaButton, setDisableBuscarPersonaJuridicaButton] =
    useState(false);
  const [disableBuscarPersonaJuridicasButton, setDisableBuscarPersonaJuridicasButton] =
    useState(false);
  const [facturaDeCobranza, setFacturaDeCobranza] = useState("");
  const [cobranzaClientes, setCobranzaClientes] = useState("");
  const [rowItem, setRowItem] = useState(rowItemInitialState);
  const [rowsItems, setRowsItems] = useState([]);
  const [rowsItemsOriginal, setRowsItemsOriginal] = useState([]);
  const [pieFactura, setPieFactura] = useState(pieFacturaInitialState);
  const [pieFacturaOriginal, setPieFacturaOriginal] = useState(pieFacturaInitialState);
  const [totalAFacturar, setTotalAFacturar] = useState(0);
  const [captionButtonItemsCuerpoFactura, setCaptionButtonItemsCuerpoFactura] =
    useState("factura-personalizada");
  const [facturaOriginalPersonalizada, setFacturaOriginalPersonalizada] =
    useState("factura-original");
  const [mostrarSubtotales, setMostrarSubtotales] = useState(true);
  const [disabledSaveCancelButtons, setDisabledSaveCancelButtons] = useState(false);

  const tableColumns = [
    {
      field: "codigoItem",
      headerName: "Código",
      headerAlign: "center",
      align: "center",
      flex: 1,
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.codigoItem;
        _val = _val ? _val.toUpperCase() : "";
        return _val;
      },
    },
    {
      field: "descripcionItem",
      headerName: "Descripción",
      headerAlign: "center",
      align: "left",
      flex: 4,
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.descripcionItem;
        _val = _val ? _val : "";
        return _val;
      },
    },
    {
      field: "cantidadItem",
      headerName: "Cantidad",
      headerAlign: "center",
      align: "right",
      flex: 1,
      type: "number",
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.cantidadItem;
        _val = _val ? _val : "";
        return _val;
      },
    },
    {
      field: "puvItem",
      headerName: "Precio Unitario",
      headerAlign: "center",
      align: "right",
      flex: 1,
      type: "number",
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.puvItem;
        _val = _val ? _val : 0;
        return _val.toFixed(2);
      },
    },
    {
      field: "totalItem",
      headerName: "Total",
      headerAlign: "center",
      align: "right",
      flex: 1,
      type: "number",
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.totalItem;
        _val = _val ? _val : 0;
        return _val.toFixed(2);
      },
    },
    {
      field: "actions",
      headerName: "Acciones",
      headerAlign: "center",
      align: "left",
      flex: 1,
      sortable: false,
      filterable: false,
      renderCell: (params) => (
        <>
          {captionButtonItemsCuerpoFactura === "factura-original" && (
            <Tooltip title="quitar item">
              <IconButton
                size="small"
                aria-label="edit"
                onClick={() => handleClickQuitarItem(params.row)}
              >
                <RemoveCircleOutlineIcon />
              </IconButton>
            </Tooltip>
          )}
        </>
      ),
    },
  ];

  const tableOptions = {
    disableRowSelectionOnClick: true,
    disableColumnMenu: true,
    disableColumnFilter: true,
    disableColumnSelector: true,
    disableDensitySelector: true,
    hideFooter: true,
    localeText: {
      noRowsLabel: "",
      noResultsOverlayLabel: "",
    },
    sx: {
      "& .MuiDataGrid-cell": {
        fontSize: "0.9em",
      },
      "& .MuiDataGrid-columnHeaders": {
        backgroundColor: "#f5f5f5",
      },
    },
  };
  //
  // ################################################################################
  //
  useEffect(() => {
    //
    // cuando inicia el componente

    const load = async () => {
      //
      // obtengo tipos de comprobantes fiscales

      setIsDoingSomething(true);
      const responseTiposComprobantesFiscales = await getCacheData("tipo_comprobante_fiscal");
      setIsDoingSomething(false);

      if (responseTiposComprobantesFiscales.ok) {
        setTiposComprobantesFiscales(responseTiposComprobantesFiscales.data.data);
      } else {
        setMessage({
          messageText: responseTiposComprobantesFiscales.messageText,
          severity: responseTiposComprobantesFiscales.messageSeverity,
        });
        setShowMessage(true);
      }

      // obtengo condiciones frente al iva

      setIsDoingSomething(true);
      const responseCondicionesFrenteIva = await getCacheData("condicion_frente_iva");
      setIsDoingSomething(false);

      if (responseCondicionesFrenteIva.ok) {
        setCondicionesFrenteIva(responseCondicionesFrenteIva.data.data);
      } else {
        setMessage({
          messageText: responseCondicionesFrenteIva.messageText,
          severity: responseCondicionesFrenteIva.messageSeverity,
        });
        setShowMessage(true);
      }

      // obtengo tipos de documentos

      setIsDoingSomething(true);
      const responseTiposDocumentos = await getCacheData("tipo_documento");
      setIsDoingSomething(false);

      if (responseTiposDocumentos.ok) {
        setTiposDocumentos(responseTiposDocumentos.data.data);
      } else {
        setMessage({
          messageText: responseTiposDocumentos.messageText,
          severity: responseTiposDocumentos.messageSeverity,
        });
        setShowMessage(true);
      }

      // obtengo datos de la cobranza

      setIsDoingSomething(true);
      const responseCobranza = await getCobranza(idCobranza);
      setIsDoingSomething(false);

      if (responseCobranza.ok) {
        //
        // obtengo los clientes de gestion de atencion

        let _clientesGAs = [];
        let _clientes = "";
        responseCobranza.data.data.cobranza_gc.forEach((item) => {
          _clientesGAs.push({
            id: item.id_cliente,
            nombreApellido: item.nombre_cliente + " " + item.apellido_cliente,
            numeroCuitCuil: item.numero_cuit_cuil_cliente,
          });
          _clientes += item.nombre_cliente + " " + item.apellido_cliente + ", ";
        });
        setClientesGAs(_clientesGAs);

        // armo para mostrar encabezado de factura

        setFacturaDeCobranza(
          "Factura para cobranza " +
          responseCobranza.data.data.cobranza.codigo +
          " del día " +
          responseCobranza.data.data.cobranza.fecha_creacion +
          " hs"
        );

        // armo para mostrar cliente o clientes de la ga

        _clientes = _clientes.slice(0, _clientes.length - 2);
        if (_clientesGAs.length === 1) {
          _clientes = "Cliente de Gestión de Atención: " + _clientes;
        } else {
          _clientes = "Clientes de Gestión de Atención: " + _clientes;
        }
        setCobranzaClientes(_clientes);

        // obtengo los totales de esta cobranza

        setPieFactura({
          ...pieFactura,
          cancelatoria: responseCobranza.data.data.cobranza.cancelatoria,
          totalDescuentos:
            responseCobranza.data.data.cobranza.importe_total_descuento +
            responseCobranza.data.data.cobranza.total_descuentos_no_cancelatorias,
          totalRecargos:
            responseCobranza.data.data.cobranza.importe_total_recargo +
            responseCobranza.data.data.cobranza.total_recargos_no_cancelatorias,
          totalCobrosACuenta:
            responseCobranza.data.data.cobranza.total_cobros_a_cuenta_no_cancelatorias,
          totalNoFacturable: responseCobranza.data.data.cobranza.total_no_facturable,
        });

        setPieFacturaOriginal({
          ...pieFactura,
          cancelatoria: responseCobranza.data.data.cobranza.cancelatoria,
          totalDescuentos:
            responseCobranza.data.data.cobranza.importe_total_descuento +
            responseCobranza.data.data.cobranza.total_descuentos_no_cancelatorias,
          totalRecargos:
            responseCobranza.data.data.cobranza.importe_total_recargo +
            responseCobranza.data.data.cobranza.total_recargos_no_cancelatorias,
          totalCobrosACuenta:
            responseCobranza.data.data.cobranza.total_cobros_a_cuenta_no_cancelatorias,
          totalNoFacturable: responseCobranza.data.data.cobranza.total_no_facturable,
        });

        setTotalAFacturar(responseCobranza.data.data.cobranza.total_a_facturar);

        // obtengo el cuerpo de la factura para esta cobranza

        let _rowsItems = [];
        responseCobranza.data.data.cuerpo_factura.forEach((item) => {
          _rowsItems.push({
            // id: item.id,
            id: uuidv4(),
            idItem: item.id,
            codigoItem: item.codigo,
            descripcionItem: item.descripcion,
            cantidadItem: item.cantidad,
            puvItem: item.precio_unitario,
            puvItemInicial: item.precio_unitario,
            tasaIva: item.tasa_iva,
            ivaItem: item.iva,
            totalItem: item.importe_total,
          });
        });
        setRowsItems(_rowsItems);
        setRowsItemsOriginal(_rowsItems);
      } else {
        setMessage({
          messageText: responseCobranza.messageText,
          severity: responseCobranza.messageSeverity,
        });
        setShowMessage(true);
      }
    };

    load();
  }, []);
  //
  // ################################################################################
  //
  useEffect(() => {
    //
    // cuando cambia el tipo de comprobante seleccionado por el usuario (factura a o b)
    // o las condiciones frente al iva asigno las condiciones frente al iva que corresponden
    // al tipo de comprobante seleccionado por el usuario

    setItemData({
      ...itemData,
      condicionFrenteIva: "",
      idCliente: "",
      tipoDocumento: "",
      numeroDocumento: "",
      numeroCuitCuil: "",
      nombre: "",
      apellido: "",
      idPersonaJuridica: "",
      razonSocial: "",
    });

    let _condicionesFrenteIvaFiltered = [];
    let _tipoComprobanteFiscalSelected = tiposComprobantesFiscales.find(
      (item) => item.id === itemData.tipoComprobanteFiscal
    )?.descripcion_corta;

    if (_tipoComprobanteFiscalSelected === "factura-b") {
      // si el tipo de comprobante seleccionado por el usuario es una factura B
      // filtro las condiciones frente al iva para que queden
      //   consumidor final
      //   iva sujeto exento
      //   responsable monotributo

      _condicionesFrenteIvaFiltered = condicionesFrenteIva.filter(
        item => item.descripcion_corta !== "responsable-inscripto"
      );
      setCondicionesFrenteIvaFiltered(_condicionesFrenteIvaFiltered);
    } else {
      // si el tipo de comprobante seleccionado por el usuario es una factura A
      // filtro las condiciones frente al iva para que quede
      //   iva responsable inscripto

      _condicionesFrenteIvaFiltered = condicionesFrenteIva.filter(
        item => item.descripcion_corta === "responsable-inscripto"
      );
      setCondicionesFrenteIvaFiltered(_condicionesFrenteIvaFiltered);
    }
  }, [itemData.tipoComprobanteFiscal, condicionesFrenteIva]);
  //
  // ################################################################################
  //
  useEffect(() => {
    //
    // cuando cambia la condición frente al iva seleccionada por el usuario
    // en condicionFrenteIvaSelected guardo la descripción corta de la condición frente
    // al iva seleccionada para el manejo de estados del componente

    setItemData({
      ...itemData,
      idCliente: "",
      tipoDocumento: "",
      numeroDocumento: "",
      numeroCuitCuil: "",
      nombre: "",
      apellido: "",
      idPersonaJuridica: "",
      razonSocial: "",
    });

    setConsumidorFinalMonotributoComprobantePara("cliente-ga");
    setDisableTipoNumeroDocumento(false);
    setDisableBuscarClienteButton(false);
    setDisableBuscarClientesButton(false);

    setDisableNumeroCuit(false);
    setDisableBuscarPersonaJuridicaButton(false);
    setDisableBuscarPersonaJuridicasButton(false);

    let _condicionFrenteIvaSelected = "";

    if (itemData.condicionFrenteIva !== "") {
      // si el usuario seleccionó una condición frente al iva

      _condicionFrenteIvaSelected = condicionesFrenteIva.find(
        item => item.id === itemData.condicionFrenteIva
      ).descripcion_corta;
    }

    setCondicionFrenteIvaSelected(_condicionFrenteIvaSelected);
  }, [itemData.condicionFrenteIva]);
  //
  // ################################################################################
  //
  useEffect(() => {
    //
    // cuando cambia el tipo de comprobante seleccionado por el usuario
    // en tipoComprobanteFiscalSelected guardo la descripción corta del tipo de comprobante
    // seleccionado para el manejo de estados del componente, inicializo los datos

    setItemData({
      ...itemData,
      condicionFrenteIva: "",
      idCliente: "",
      tipoDocumento: "",
      numeroDocumento: "",
      numeroCuitCuil: "",
      nombre: "",
      apellido: "",
      idPersonaJuridica: "",
      razonSocial: "",
    });

    setConsumidorFinalMonotributoComprobantePara("cliente-ga");
    setDisableTipoNumeroDocumento(false);
    setDisableBuscarClienteButton(false);
    setDisableBuscarClientesButton(false);

    setDisableNumeroCuit(false);
    setDisableBuscarPersonaJuridicaButton(false);
    setDisableBuscarPersonaJuridicasButton(false);

    let _tipoComprobanteFiscalSelected = "";

    if (itemData.tipoComprobanteFiscal !== "") {
      // si el usuario seleccionó un tipo de comprobante

      _tipoComprobanteFiscalSelected = tiposComprobantesFiscales.find(
        (item) => item.id === itemData.tipoComprobanteFiscal
      ).descripcion_corta;
    }

    setTipoComprobanteFiscalSelected(_tipoComprobanteFiscalSelected);
    setRowItem(rowItemInitialState);

    // si hay filas en rowsItems, las filas de la factura, recalculo los valores
    // de la factura dependiendo de si es factura-a o factura-b

    rowsItems.forEach((item) => {
      if (facturaOriginalPersonalizada === "factura-original") {
        if (_tipoComprobanteFiscalSelected === "factura-b") {
          // si es factura B
          item.puvItem = item.puvItemInicial;
          item.totalItem = item.cantidadItem * item.puvItem;
        } else {
          // si es factura A
          item.puvItem = item.puvItemInicial - item.ivaItem;
          item.totalItem = item.cantidadItem * item.puvItemInicial;
        }
      } else {
        if (_tipoComprobanteFiscalSelected === "factura-b") {
          // si es factura B
          item.puvItem = item.puvItemInicial + item.ivaItem;
          item.totalItem = item.cantidadItem * item.puvItem;
        } else {
          // si es factura A
          item.puvItem = item.puvItemInicial;
          item.totalItem = item.cantidadItem * (item.puvItemInicial + item.ivaItem);
        }
      }
    });
  }, [itemData.tipoComprobanteFiscal]);
  //
  // ################################################################################
  //
  useEffect(() => {
    //
    // cuando cambia el id del cliente seleccionado por el usuario
    // este efecto solo se encarga de asignar el numero de cuit/cuil del cliente
    // cuando en factura b el usuario selecciona un cliente de gestion de atencion

    if (itemData.idCliente !== "") {
      // si el usuario seleccionó un cliente

      if (tipoComprobanteFiscalSelected === "factura-b") {
        // si el tipo de comprobante seleccionado por el usuario es una factura B

        if (consumidorFinalMonotributoComprobantePara === "cliente-ga") {
          // si el comprobante es para un cliente de gestion de atencion
          // obtengo y asigno el numero de cuit/cuil del cliente seleccionado

          let _numeroCuitCuil = clientesGAs.find(
            (item) => item.id === itemData.idCliente
          ).numeroCuitCuil;

          setItemData({
            ...itemData,
            numeroCuitCuil: _numeroCuitCuil,
          });
        }
      }
    }
  }, [itemData.idCliente]);
  //
  // ################################################################################
  //
  useEffect(() => {
    //
    // cuando cambia la cantidad o el precio unitario del item de la factura

    let _cantidadItem =
      rowItem.cantidadItem === "" || isNaN(rowItem.cantidadItem) ? 1 : rowItem.cantidadItem;

    let _puvItem =
      rowItem.puvItem === "" || (isNaN(rowItem.puvItem) && rowItem.puvItem !== "-")
        ? 0
        : rowItem.puvItem;

    let _totalItem = 0;

    if (tipoComprobanteFiscalSelected === "factura-b") {
      // si el tipo de comprobante seleccionado por el usuario es una factura B
      _totalItem = +_cantidadItem * +_puvItem;
    } else {
      // si el tipo de comprobante seleccionado por el usuario es una factura A
      _totalItem = +_cantidadItem * (+_puvItem + (+_puvItem * 21) / 100);
    }

    setRowItem({
      ...rowItem,
      cantidadItem: _cantidadItem,
      puvItem: _puvItem,
      tasaIva: 21,
      ivaItem: roundNumber(_puvItem * 0.21),
      totalItem: roundNumber(_totalItem),
    });
  }, [rowItem.cantidadItem, rowItem.puvItem]);
  //
  // ################################################################################
  //
  useEffect(() => {
    //
    // cuando se agrega o se quita un item de la factura

    let _subTotalItems = 0;
    let _subTotal = 0;
    let _iva = 0;
    let _total = 0;

    rowsItems.forEach((item) => {
      _subTotalItems += item.totalItem;
    });

    if (pieFactura.cancelatoria) {
      // si la cobranza es cancelatoria

      _subTotal =
        _subTotalItems -
        pieFactura.totalDescuentos +
        pieFactura.totalRecargos -
        pieFactura.totalCobrosACuenta -
        pieFactura.totalNoFacturable;
    } else {
      // si la cobranza no es cancelatoria

      _subTotal = _subTotalItems;
    }

    _subTotal = _subTotal / 1.21;
    _iva = _subTotal * 0.21;
    _total = _subTotal + _iva;

    setPieFactura({
      ...pieFactura,
      subTotalItems: +_subTotalItems.toFixed(2),
      subTotalFactura: +_subTotal.toFixed(2),
      ivaFactura: +_iva.toFixed(2),
      totalFactura: +_total.toFixed(2),
    });
  }, [rowsItems]);
  //
  // ################################################################################
  //
  const handleChange = (e) => {
    setItemData({
      ...itemData,
      [e.target.name]: e.target.type === "checkbox" ? e.target.checked : e.target.value,
    });
  };
  //
  // ################################################################################
  //
  const handleChangeRowItem = (e) => {
    setRowItem({
      ...rowItem,
      [e.target.name]: e.target.type === "checkbox" ? e.target.checked : e.target.value,
    });
  };
  //
  // ################################################################################
  //
  const handleBlurCantidadItem = (e) => {
    let _cantidadItem = e.target.value;
    _cantidadItem =
      _cantidadItem === "" || isNaN(_cantidadItem) || parseInt(+_cantidadItem) <= 0
        ? 1
        : parseInt(+_cantidadItem);

    setRowItem({
      ...rowItem,
      cantidadItem: _cantidadItem,
    });
  };
  //
  // ################################################################################
  //
  const handleBlurPuvItem = (e) => {
    let _puvItem = e.target.value;
    _puvItem = _puvItem === "" || isNaN(+_puvItem) ? 1 : +_puvItem;

    setRowItem({
      ...rowItem,
      puvItem: _puvItem,
    });
  };
  //
  // ################################################################################
  //
  const handleChangeConsumidorFinalComprobantePara = (e, newValue) => {
    //
    // cuando cambia el valor del toggle button group de comprobante para
    // cliente de gestion de atencion o para otra persona

    setConsumidorFinalMonotributoComprobantePara(newValue);

    setItemData({
      ...itemData,
      idCliente: "",
      tipoDocumento: "",
      numeroDocumento: "",
      numeroCuitCuil: "",
      nombre: "",
      apellido: "",
      idPersonaJuridica: "",
      razonSocial: "",
    });

    setDisableTipoNumeroDocumento(false);
    setDisableBuscarClienteButton(false);
    setDisableBuscarClientesButton(false);
  };
  //
  // ################################################################################
  //
  const buscarCliente = () => {
    //
    // cuando el usuario hace click en el botón buscar para obtener
    // los datos de un cliente dado tipo y numero de documento

    setItemData({
      ...itemData,
      idCliente: "",
      numeroDocumento: "",
      numeroCuitCuil: "",
      nombre: "",
      apellido: "",
      idPersonaJuridica: "",
      razonSocial: "",
    });

    if (itemData.tipoDocumento === "") {
      // si el usuario no indico un tipo de documento

      setMessage({
        severity: "error",
        messageText: "Debes seleccionar el tipo de documento de la persona",
      });
      setShowMessage(true);
      return;
    }

    if (
      !itemData.numeroDocumento ||
      !isPositiveInteger(itemData.numeroDocumento) ||
      itemData.numeroDocumento.length < 7
    ) {
      // si el usuario no indico un número de documento o el número de documento no es valido

      setMessage({
        severity: "error",
        messageText: "El documento de la persona debe ser un número de 7 o más dígitos",
      });
      setShowMessage(true);
      return;
    }

    // busco cliente con tipo y numero de documento dados

    const loadCliente = async () => {
      let _params = {
        tipoDocumento: itemData.tipoDocumento,
        numeroDocumento: itemData.numeroDocumento,
      };

      setIsDoingSomething(true);
      const response = await getClienteByDocument(_params);
      setIsDoingSomething(false);

      if (response.ok) {
        if (!response.exist) {
          // si no existe el cliente

          setMessage({
            severity: "error",
            messageText: "No existe un cliente con el documento ingresado",
          });
          setShowMessage(true);
          return;
        }

        // si existe el cliente

        setItemData({
          ...itemData,
          idCliente: response.data.data.id,
          numeroDocumento: response.data.data.num_doc,
          numeroCuitCuil: response.data.data.numero_cuit_cuil,
          nombre: response.data.data.nombre,
          apellido: response.data.data.apellido,
          idPersonaJuridica: "",
          razonSocial: "",
        });

        setDisableTipoNumeroDocumento(true);
        setDisableBuscarClienteButton(true);
        setDisableBuscarClientesButton(true);
      } else {
        setMessage({
          messageText: response.messageText,
          severity: response.messageSeverity,
        });
        setShowMessage(true);
      }
    };

    loadCliente();
  };
  //
  // ################################################################################
  //
  const handleClickOpenBuscarCliente = () => {
    // abre el diálogo de búsqueda de clientes

    setOpenDialogBuscarCliente(true);
  };
  //
  // ################################################################################
  //
  const handleCloseDialogBuscarCliente = () => {
    // cierra el diálogo de búsqueda de clientes

    setOpenDialogBuscarCliente(false);
  };
  //
  // ################################################################################
  //
  const handleSelectCliente = (cliente) => {
    // cuando el usuario selecciona un cliente en el diálogo de búsqueda de clientes

    setItemData({
      ...itemData,
      idCliente: cliente.id,
      tipoDocumento: cliente.id_tipo_documento,
      numeroDocumento: cliente.num_doc,
      numeroCuitCuil: cliente.numero_cuit_cuil,
      nombre: cliente.nombre,
      apellido: cliente.apellido,
      idPersonaJuridica: "",
      razonSocial: "",
    });

    setOpenDialogBuscarCliente(false);
    setDisableTipoNumeroDocumento(true);
    setDisableBuscarClienteButton(true);
    setDisableBuscarClientesButton(true);
  };
  //
  // ################################################################################
  //
  const limpiarCliente = () => {
    // limpia los datos del cliente seleccionado

    setItemData({
      ...itemData,
      idCliente: "",
      tipoDocumento: "",
      numeroDocumento: "",
      numeroCuitCuil: "",
      nombre: "",
      apellido: "",
      idPersonaJuridica: "",
      razonSocial: "",
    });

    setDisableTipoNumeroDocumento(false);
    setDisableBuscarClienteButton(false);
    setDisableBuscarClientesButton(false);
  };
  //
  // ################################################################################
  //
  const buscarPersonaJuridica = () => {
    // cuando el usuario hace click en el botón buscar para obtener
    // los datos de una persona juridica dado su numero de cuit

    setItemData({
      ...itemData,
      idCliente: "",
      numeroDocumento: "",
      numeroCuitCuil: "",
      nombre: "",
      apellido: "",
      idPersonaJuridica: "",
      razonSocial: "",
    });

    if (
      !itemData.numeroCuitCuil ||
      !isPositiveInteger(itemData.numeroCuitCuil) ||
      itemData.numeroCuitCuil.length < 11
    ) {
      // si el usuario no indico un número de cuit o el número de cuit no es valido
      setMessage({
        severity: "error",
        messageText: "El CUIT debe ser ingresado sin guiones ni espacios",
      });
      setShowMessage(true);
      return;
    }

    // busco persona juridica con cuit dado

    const loadPersonaJuridica = async () => {
      let _params = {
        numeroCuitCuil: itemData.numeroCuitCuil,
      };

      setIsDoingSomething(true);
      const response = await getPersonaJuridicaByCuit(_params);
      setIsDoingSomething(false);

      if (response.ok) {
        if (!response.exist) {
          // si no existe la persona juridica
          setMessage({
            severity: "error",
            messageText: "No existe una persona juridica con el CUIT ingresado",
          });
          setShowMessage(true);
          return;
        }

        // si existe la persona juridica

        if (response.data.data.id_condicion_frente_iva !== itemData.condicionFrenteIva) {
          // si la condicion frente al iva de la persona juridica seleccionada no coincide
          // con la condicion frente al iva seleccionada por el usuario

          setMessage({
            severity: "error",
            messageText:
              "La condición frente al IVA de la persona juridica no coincide con la seleccionada para el comprobante",
          });
          setShowMessage(true);
          return;
        }

        setItemData({
          ...itemData,
          idPersonaJuridica: response.data.data.id,
          numeroCuitCuil: response.data.data.numero_cuit,
          razonSocial: response.data.data.razon_social,
        });
        setDisableNumeroCuit(true);
        setDisableBuscarPersonaJuridicaButton(true);
        setDisableBuscarPersonaJuridicasButton(true);
      } else {
        setMessage({
          messageText: response.messageText,
          severity: response.messageSeverity,
        });
        setShowMessage(true);
      }
    };
    loadPersonaJuridica();
  };
  //
  // ################################################################################
  //
  const handleClickOpenBuscarPersonaJuridica = () => {
    // abre el diálogo de búsqueda de clientes

    setOpenDialogBuscarPersonaJuridica(true);
  };
  //
  // ################################################################################
  //
  const handleCloseDialogBuscarPersonaJuridica = () => {
    // cierra el diálogo de búsqueda de clientes

    setOpenDialogBuscarPersonaJuridica(false);
  };
  //
  // ################################################################################
  //
  const handleSelectPersonaJuridica = (personaJuridica) => {
    // cuando el usuario selecciona un cliente en el diálogo de búsqueda de clientes

    if (personaJuridica.id_condicion_frente_iva !== itemData.condicionFrenteIva) {
      // si la condicion frente al iva de la persona juridica seleccionada no coincide
      // con la condicion frente al iva seleccionada por el usuario

      setMessage({
        severity: "error",
        messageText:
          "La condición frente al IVA de la persona juridica no coincide con la seleccionada para el comprobante",
      });
      setShowMessage(true);
      return;
    }

    setItemData({
      ...itemData,
      idCliente: "",
      tipoDocumento: "",
      numeroDocumento: "",
      numeroCuitCuil: personaJuridica.numero_cuit,
      nombre: "",
      apellido: "",
      idPersonaJuridica: personaJuridica.id,
      razonSocial: personaJuridica.razon_social,
    });

    setOpenDialogBuscarPersonaJuridica(false);
    setDisableNumeroCuit(true);
    setDisableBuscarPersonaJuridicaButton(true);
    setDisableBuscarPersonaJuridicasButton(true);
  };
  //
  // ################################################################################
  //
  const limpiarPersonaJuridica = () => {
    // limpia los datos del cliente seleccionado

    setItemData({
      ...itemData,
      idCliente: "",
      tipoDocumento: "",
      numeroDocumento: "",
      numeroCuitCuil: "",
      nombre: "",
      apellido: "",
      idPersonaJuridica: "",
      razonSocial: "",
    });

    setDisableNumeroCuit(false);
    setDisableBuscarPersonaJuridicaButton(false);
    setDisableBuscarPersonaJuridicasButton(false);
  };
  //
  // ################################################################################
  //
  const addRowItem = () => {
    //
    // agrega un item a la lista de items de la factura
    let _id = uuidv4();
    let _rowItem = {
      id: _id,
      idItem: _id,
      codigoItem: rowItem.codigoItem,
      descripcionItem: rowItem.descripcionItem,
      cantidadItem: rowItem.cantidadItem,
      puvItem: rowItem.puvItem,
      puvItemInicial: rowItem.puvItem,
      tasaIva: rowItem.tasaIva,
      ivaItem: rowItem.ivaItem,
      totalItem: rowItem.totalItem,
    };

    let _rowsItems = [...rowsItems];
    _rowsItems.push(_rowItem);

    setRowsItems(_rowsItems);
    setRowItem(rowItemInitialState);
  };
  //
  // ################################################################################
  //
  const handleClickQuitarItem = (parRow) => {
    let _rowsItems = rowsItems.filter((item) => item.idItem !== parRow.idItem);
    setRowsItems(_rowsItems);
  };
  //
  // ################################################################################
  //
  const handleItemsCuerpoFactura = () => {
    if (captionButtonItemsCuerpoFactura === "factura-original") {
      // si el usuario selecciona factura original

      setFacturaOriginalPersonalizada("factura-original");
      setRowItem(rowItemInitialState);
      setRowsItems(rowsItemsOriginal);
      setPieFactura(pieFacturaOriginal);
      setMostrarSubtotales(pieFactura.cancelatoria ? true : false);
      setCaptionButtonItemsCuerpoFactura("factura-personalizada");
    } else {
      // si el usuario selecciona factura personalizada

      setFacturaOriginalPersonalizada("factura-personalizada");
      setRowsItems([]);
      setPieFactura({
        ...pieFacturaOriginal,
        subTotalItems: 0,
        totalDescuentos: 0,
        totalRecargos: 0,
        totalCobrosACuenta: 0,
        totalNoFacturable: 0,
        subTotalFactura: 0,
        ivaFactura: 0,
        totalFactura: 0,
      });
      setMostrarSubtotales(false);
      setCaptionButtonItemsCuerpoFactura("factura-original");
    }
  };
  //
  // ################################################################################
  //
  const handleCancel = () => {
    window.close();
  };
  //
  // ################################################################################
  //
  const handleSave = () => {
    // validaciones

    if (tipoComprobanteFiscalSelected === "") {
      // si no se ha seleccionado un tipo de comprobante
      setMessage({
        severity: "error",
        messageText: "Debes seleccionar el Tipo de Comprobante a emitir",
      });
      setShowMessage(true);
      return;
    }

    if (condicionFrenteIvaSelected === "") {
      // si no se ha seleccionado la condicion frente al iva
      setMessage({
        severity: "error",
        messageText: "Debes seleccionar la condición frente al IVA del cliente",
      });
      setShowMessage(true);
      return;
    }

    if (
      condicionFrenteIvaSelected === "consumidor-final" ||
      condicionFrenteIvaSelected === "responsable-monotributo"
    ) {
      // si la condicion frente al iva es consumidor final o responsable monotributo
      if (!consumidorFinalMonotributoComprobantePara) {
        // si no se ha seleccionado para quien es el comprobante
        setMessage({
          severity: "error",
          messageText: "Debes seleccionar para quien es el comprobante",
        });
        setShowMessage(true);
        return;
      }

      if (consumidorFinalMonotributoComprobantePara === "cliente-ga") {
        // si el comprobante es para un cliente de las gas cobradas

        if (itemData.idCliente === "") {
          // si no se ha seleccionado un cliente
          setMessage({
            severity: "error",
            messageText: "Debes seleccionar un cliente para emitir el comprobante",
          });
          setShowMessage(true);
          return;
        }
      }

      if (consumidorFinalMonotributoComprobantePara === "cliente-otro") {
        // si el comprobante es para un cliente de las gas cobradas

        if (!disableBuscarClientesButton) {
          // si no se ha indicado tipo y numero de documento

          setMessage({
            severity: "error",
            messageText: "Debes seleccionar un cliente para emitir el comprobante",
          });
          setShowMessage(true);
          return;
        }
      }
    } else {
      // si la condicion frente al iva es exento o responsable inscripto

      if (!disableBuscarPersonaJuridicasButton) {
        // si no se ha indicado tipo y numero de documento
        setMessage({
          severity: "error",
          messageText: "Debes seleccionar un cliente para emitir el comprobante",
        });
        setShowMessage(true);
        return;
      }
    }

    if (pieFactura.totalFactura !== totalAFacturar) {
      // si el total de los items del cuerpo de la factua difiere del total a facturar
      setMessage({
        severity: "error",
        messageText: `No es correcto el total de la factura. Debe ser igual a $ ${totalAFacturar}`,
      });
      setShowMessage(true);
      return;
    }

    let _factura = prepararFacturaObject();

    save(_factura);
  };
  //
  // ################################################################################
  //
  const save = async (parFactura) => {
    // setDisabledSaveCancelButtons(true);

    setIsDoingSomething(true);
    const response = await saveFactura("new", parFactura);
    setIsDoingSomething(false);

    setMessage({
      messageText: response.messageText,
      severity: response.messageSeverity,
    });
    setShowMessage(true);

    if (response.ok) {
      setTimeout(() => {
        window.close();
      }, 1000);
    }
  };
  //
  // ################################################################################
  //
  const prepararFacturaObject = () => {
    let _facturaRows = [];
    rowsItems.forEach((item) => {
      _facturaRows.push({
        id_articulo: pieFactura.cancelatoria
          ? facturaOriginalPersonalizada === "factura-personalizada"
            ? null
            : item.idItem
          : null,
        codigo: item.codigoItem,
        descripcion: item.descripcionItem,
        cantidad: item.cantidadItem,
        precio_unitario: roundNumber(item.puvItem),
        iva: roundNumber(item.ivaItem),
      });
    });

    let _factura = {
      id_cobranza: idCobranza,
      id_tipo_comprobante_fiscal: itemData.tipoComprobanteFiscal,
      id_condicion_frente_iva: itemData.condicionFrenteIva,
      id_cliente: itemData.idCliente,
      id_persona_juridica: itemData.idPersonaJuridica,
      factura_personalizada:
        facturaOriginalPersonalizada === "factura-personalizada" ? true : false,
      subtotal0: pieFactura.subTotalItems,
      descuento: pieFactura.totalDescuentos,
      recargo: pieFactura.totalRecargos,
      acuenta: pieFactura.totalCobrosACuenta,
      otros_no_facturables: pieFactura.totalNoFacturable,
      subtotal: pieFactura.subTotalFactura,
      iva: pieFactura.ivaFactura,
      total: pieFactura.totalFactura,
      factura_rows_list: _facturaRows,
    };

    return _factura;
  };
  //
  // ################################################################################
  //
  return (
    <>
      <Paper elevation={0} sx={{ mx: 0.5, maxWidth: "100%" }}>
        <Grid container spacing={1}>
          {/* datos de cabecera de cobranza */}

          <Grid item xs={12} md={6} lg={6} sx={{ mb: 1 }}>
            <Typography variant="h5" display="block" gutterBottom>
              {facturaDeCobranza}
            </Typography>
            <Typography variant="h8" display="block" gutterBottom>
              {cobranzaClientes}
            </Typography>
          </Grid>

          {/* total a facturar */}

          <Grid item xs={12} md={6} lg={6} sx={{ mb: 1, textAlign: "right" }}>
            <Typography variant="h8" display="block" gutterBottom>
              TOTAL A FACTURAR
            </Typography>
            <Typography variant="h5" display="block" gutterBottom>
              ${" "}
              {totalAFacturar.toLocaleString(
                settings.numericLocales.language,
                settings.numericLocales.options
              )}
            </Typography>
          </Grid>
        </Grid>

        <Box sx={{ border: "1px solid LightGrey", p: 2, borderRadius: "5px", m: 0, mb: 1 }}>
          <Box sx={{ mb: 1 }}>
            {/* tipo de comprobante y condicion frente a iva */}
            <Grid container spacing={1}>
              {/* Tipo de comprobante */}

              <Grid item xs={12} md={6} lg={6}>
                <FormControl sx={{ width: "100%" }}>
                  <InputLabel id="tipo-comprobante-fiscal-select-label">
                    Tipo de Comprobante
                  </InputLabel>
                  <Select
                    sx={{ width: "100%", mr: 1 }}
                    labelId="tipo-comprobante-fiscal"
                    label="Tipo de Comprobante"
                    id="tipo-comprobante-fiscal"
                    name="tipoComprobanteFiscal"
                    value={itemData.tipoComprobanteFiscal}
                    size="small"
                    onChange={handleChange}
                  >
                    {tiposComprobantesFiscales.map((item) => (
                      <MenuItem key={item.id} value={item.id}>
                        {item.descripcion}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>

              {/* condicion frente al iva */}

              <Grid item xs={12} md={6} lg={6}>
                <FormControl sx={{ width: "100%" }}>
                  <InputLabel id="condicion-frente-iva-select-label">
                    Condición frente al IVA
                  </InputLabel>
                  <Select
                    sx={{ width: "100%", mr: 1 }}
                    labelId="condicion-frente-iva"
                    label="Condición frente al IVA"
                    id="condicion-frente-iva"
                    name="condicionFrenteIva"
                    value={itemData.condicionFrenteIva}
                    size="small"
                    onChange={handleChange}
                  >
                    {condicionesFrenteIvaFiltered.map((item) => (
                      <MenuItem key={item.id} value={item.id}>
                        {item.descripcion}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
            </Grid>
          </Box>

          <Box sx={{ mx: 1, px: 1, pb: 1 }}>
            {(condicionFrenteIvaSelected === "consumidor-final" ||
              condicionFrenteIvaSelected === "responsable-monotributo") && (
                <>
                  {/* si la condicion frente a iva seleccionada por el usuario es // consumidor
                final o monotributista */}
                  <Box sx={{ m: 0, mb: 2 }}>
                    <Grid container spacing={1}>
                      <Grid item xs={12} sm={12} md={12} lg={12}>
                        {/* factura para cliente de gestion de atencion o para otra persona */}

                        <ToggleButtonGroup
                          color="primary"
                          value={consumidorFinalMonotributoComprobantePara}
                          exclusive={true}
                          onChange={handleChangeConsumidorFinalComprobantePara}
                        >
                          <ToggleButton value="cliente-ga" sx={{ mr: 1 }} size="medium">
                            Factura para cliente de Gestión de Atencion
                          </ToggleButton>
                          <ToggleButton value="cliente-otro" size="medium">
                            Factura para Otra persona
                          </ToggleButton>
                        </ToggleButtonGroup>
                      </Grid>
                    </Grid>
                  </Box>

                  {consumidorFinalMonotributoComprobantePara === "cliente-ga" && (
                    //
                    // si el comprobante es para un cliente de gestion de atencion
                    <>
                      <Grid container spacing={1}>
                        <Grid item xs={12} sm={12} md={6} lg={4}>
                          {/* select de cliente de ga */}
                          <FormControl sx={{ width: "100%" }}>
                            <InputLabel id="cliente-ga-select-label">Clientes</InputLabel>
                            <Select
                              sx={{ width: "100%", mr: 1 }}
                              labelId="cliente-ga"
                              label="Clientes"
                              id="cliente-ga"
                              name="idCliente"
                              value={itemData.idCliente}
                              size="small"
                              onChange={handleChange}
                            >
                              {clientesGAs.map((item) => (
                                <MenuItem key={item.id} value={item.id}>
                                  {item.nombreApellido}
                                </MenuItem>
                              ))}
                            </Select>
                          </FormControl>
                        </Grid>

                        {/* numero de cuit/cuil del cliente */}

                        <Grid item xs={12} sm={12} md={6} lg={4}>
                          <TextField
                            sx={{ width: "100%" }}
                            id="numero-cuit-cuil"
                            label="CUIT/CUIL"
                            variant="outlined"
                            size="small"
                            name="numeroCuitCuil"
                            value={itemData.numeroCuitCuil}
                            disabled={true}
                          />
                        </Grid>
                      </Grid>
                    </>
                  )}
                  {consumidorFinalMonotributoComprobantePara === "cliente-otro" && (
                    //
                    // si el comprobante es para otro cliente
                    <>
                      <Box sx={{ m: 0, mb: 1 }}>
                        <Grid container spacing={1}>
                          <Grid item xs={12} sm={12} md={4} lg={3}>
                            {/* tipo de documento */}
                            <FormControl sx={{ width: "100%" }} disabled={disableTipoNumeroDocumento}>
                              <InputLabel id="tipo-documento-select-label">
                                Tipo de Documento
                              </InputLabel>
                              <Select
                                sx={{ width: "100%", mr: 1 }}
                                labelId="tipo-documento-select-label"
                                label="Tipo de documento"
                                id="tipo-documento-select"
                                name="tipoDocumento"
                                value={itemData.tipoDocumento}
                                size="small"
                                onChange={handleChange}
                              >
                                {tiposDocumentos.map((item) => (
                                  <MenuItem key={item.id} value={item.id}>
                                    {item.descripcion}
                                  </MenuItem>
                                ))}
                              </Select>
                            </FormControl>
                          </Grid>

                          {/* numero de documento */}

                          <Grid item xs={12} sm={12} md={4} lg={3}>
                            <TextField
                              sx={{ width: "100%" }}
                              inputProps={{
                                autoComplete: "off",
                              }}
                              id="numero-documento"
                              label="Número"
                              variant="outlined"
                              size="small"
                              name="numeroDocumento"
                              value={itemData.numeroDocumento}
                              onChange={handleChange}
                              disabled={disableTipoNumeroDocumento}
                            />
                          </Grid>

                          <Grid item xs={12} sm={12} md={4} lg={6}>
                            {/* boton par buscar el cliente dado su tipo y numero de documento */}

                            <Tooltip title="buscar">
                              <Fab
                                sx={{ ml: 1, mr: 1 }}
                                color="primary"
                                aria-label="add"
                                size="small"
                                onClick={buscarCliente}
                                disabled={disableBuscarClienteButton}
                              >
                                <SearchIcon />
                              </Fab>
                            </Tooltip>

                            {/* boton buscar clientes para abrir el dialog de busqueda de clientes */}

                            <Tooltip title="Buscar Clientes">
                              <Fab
                                sx={{ ml: 1, mr: 1 }}
                                color="primary"
                                aria-label="add"
                                size="small"
                                onClick={handleClickOpenBuscarCliente}
                                disabled={disableBuscarClientesButton}
                              >
                                <ZoomInOutlinedIcon />
                              </Fab>
                            </Tooltip>

                            {/* boton limpiar */}

                            <Tooltip title="limpiar">
                              <Fab
                                sx={{ ml: 1, mr: 1 }}
                                color="outlined"
                                aria-label="add"
                                size="small"
                                onClick={limpiarCliente}
                              >
                                <CleaningServicesIcon />
                              </Fab>
                            </Tooltip>
                          </Grid>
                        </Grid>
                      </Box>

                      <Grid container spacing={1}>
                        {/* nombre */}

                        <Grid item xs={12} sm={4} md={4} lg={4}>
                          <TextField
                            sx={{ width: "100%" }}
                            id="nombre"
                            label="Nombre"
                            variant="outlined"
                            size="small"
                            name="nombre"
                            value={itemData.nombre}
                            disabled
                          />
                        </Grid>

                        {/* apellido */}

                        <Grid item xs={12} sm={4} md={4} lg={4}>
                          <TextField
                            sx={{ width: "100%" }}
                            id="apellido"
                            label="Apellido"
                            variant="outlined"
                            size="small"
                            name="apellido"
                            value={itemData.apellido}
                            disabled
                          />
                        </Grid>

                        {/* numero cuit/cuil */}

                        <Grid item xs={12} sm={4} md={4} lg={4}>
                          <TextField
                            sx={{ width: "100%" }}
                            id="numero-cuit-cuil"
                            label="CUIT/CUIL"
                            variant="outlined"
                            size="small"
                            name="numeroCuitCuil"
                            value={itemData.numeroCuitCuil}
                            disabled
                          />
                        </Grid>
                      </Grid>
                    </>
                  )}
                </>
              )}

            {(condicionFrenteIvaSelected === "exento" ||
              condicionFrenteIvaSelected === "responsable-inscripto") && (
                <>
                  <Box sx={{ m: 0, mb: 1 }}>
                    <Grid container spacing={1}>
                      {/* numero de cuit/cuil del cliente */}

                      <Grid item xs={12} sm={6} md={6} lg={4}>
                        <TextField
                          sx={{ width: "100%" }}
                          id="numero-cuit"
                          label="CUIT"
                          variant="outlined"
                          size="small"
                          name="numeroCuitCuil"
                          value={itemData.numeroCuitCuil}
                          onChange={handleChange}
                          disabled={disableNumeroCuit}
                        />
                      </Grid>

                      {/* boton par buscar la persona juridica dado su numero de cuit */}

                      <Grid item xs={12} sm={6} md={6} lg={8}>
                        {/* boton par buscar el cliente dado su tipo y numero de documento */}

                        <Tooltip title="buscar persona jurídica">
                          <Fab
                            sx={{ ml: 1, mr: 1 }}
                            color="primary"
                            aria-label="add"
                            size="small"
                            onClick={buscarPersonaJuridica}
                            disabled={disableBuscarPersonaJuridicaButton}
                          >
                            <SearchIcon />
                          </Fab>
                        </Tooltip>

                        {/* boton buscar clientes para abrir el dialog de busqueda de clientes */}

                        <Tooltip title="buscar personas jurídicas">
                          <Fab
                            sx={{ ml: 1, mr: 1 }}
                            color="primary"
                            aria-label="add"
                            size="small"
                            onClick={handleClickOpenBuscarPersonaJuridica}
                            disabled={disableBuscarPersonaJuridicasButton}
                          >
                            <ZoomInOutlinedIcon />
                          </Fab>
                        </Tooltip>

                        {/* boton limpiar */}

                        <Tooltip title="limpiar">
                          <Fab
                            sx={{ ml: 1, mr: 1 }}
                            color="outlined"
                            aria-label="add"
                            size="small"
                            onClick={limpiarPersonaJuridica}
                          >
                            <CleaningServicesIcon />
                          </Fab>
                        </Tooltip>
                      </Grid>
                    </Grid>
                  </Box>
                  <Grid container>
                    {/* razon social */}
                    <Grid item xs={12} sm={12} md={12} lg={6}>
                      <TextField
                        sx={{ width: "100%" }}
                        id="razonSocial"
                        label="Razón Social"
                        variant="outlined"
                        size="small"
                        name="nombre"
                        value={itemData.razonSocial}
                        disabled
                      />
                    </Grid>
                  </Grid>
                </>
              )}
          </Box>
        </Box>

        <Box sx={{ border: "1px solid LightGrey", borderRadius: "5px", p: 2, mb: 2 }}>
          <Box sx={{ width: "100%", pb: 2 }}>
            <Grid container spacing={1}>
              <Grid item xs={12} sm={6} md={8} lg={10}>
                <Typography variant="h7" display="block" gutterBottom>
                  {facturaOriginalPersonalizada === "factura-original"
                    ? "Factura original"
                    : "Personalizando factura"}
                </Typography>
              </Grid>
              <Grid item xs={12} sm={6} md={4} lg={2}>
                <Box sx={{ textAlign: "right" }}>
                  <Button
                    sx={{ mr: 1, width: "100%" }}
                    variant="outlined"
                    size="small"
                    onClick={handleItemsCuerpoFactura}
                  >
                    {captionButtonItemsCuerpoFactura === "factura-original"
                      ? "Emitir Factura original"
                      : "Personalizar Factura"}
                  </Button>
                </Box>
              </Grid>
            </Grid>
          </Box>

          {facturaOriginalPersonalizada === "factura-personalizada" && (
            <Box sx={{ width: "100%", pb: 2 }}>
              <Grid container spacing={1}>
                {/*  codigo de item de factura */}

                <Grid item xs={12} sm={12} md={4} lg={2}>
                  <TextField
                    sx={{ width: "100%" }}
                    inputProps={{ autoComplete: "off", style: { textAlign: "center" } }}
                    id="codigoItem"
                    label="Código"
                    variant="outlined"
                    size="small"
                    name="codigoItem"
                    value={rowItem.codigoItem}
                    onChange={handleChangeRowItem}
                  />
                </Grid>

                {/*  descripcion de item de factura */}

                <Grid item xs={12} sm={12} md={8} lg={4}>
                  <TextField
                    sx={{ width: "100%" }}
                    inputProps={{ autoComplete: "off" }}
                    id="descripcionItem"
                    label="Descripción"
                    variant="outlined"
                    size="small"
                    name="descripcionItem"
                    value={rowItem.descripcionItem}
                    onChange={handleChangeRowItem}
                  />
                </Grid>

                {/*  cantidad item de factura */}

                <Grid item xs={12} sm={12} md={6} lg={1}>
                  <TextField
                    sx={{ width: "100%" }}
                    inputProps={{ autoComplete: "off", style: { textAlign: "center" } }}
                    id="cantidadItem"
                    label="Cantidad"
                    variant="outlined"
                    size="small"
                    name="cantidadItem"
                    value={rowItem.cantidadItem}
                    onChange={handleChangeRowItem}
                    onBlur={handleBlurCantidadItem}
                  />
                </Grid>

                {/*  precio unitario de item de factura */}

                <Grid item xs={12} sm={12} md={6} lg={2}>
                  <TextField
                    sx={{ width: "100%" }}
                    inputProps={{ autoComplete: "off", style: { textAlign: "center" } }}
                    id="puvItem"
                    label="Precio Unitario"
                    variant="outlined"
                    size="small"
                    name="puvItem"
                    value={rowItem.puvItem.toLocaleString(
                      settings.numericLocales.language,
                      settings.numericLocales.options
                    )}
                    onChange={handleChangeRowItem}
                    onBlur={handleBlurPuvItem}
                  />
                </Grid>

                {/*  precio total de item de factura */}

                <Grid item xs={12} sm={12} md={6} lg={2}>
                  <TextField
                    sx={{ width: "100%" }}
                    inputProps={{ style: { textAlign: "center" } }}
                    id="totalItem"
                    label="Total"
                    variant="outlined"
                    size="small"
                    name="totalItem"
                    value={rowItem.totalItem.toLocaleString(
                      settings.numericLocales.language,
                      settings.numericLocales.options
                    )}
                    disabled
                  />
                </Grid>

                {/* fab para agregar item */}

                <Grid item xs={12} sm={12} md={6} lg={1}>
                  <Fab
                    color="primary"
                    aria-label="add"
                    size="small"
                    disabled={
                      rowItem.codigoItem === "" ||
                      rowItem.descripcionItem === "" ||
                      +rowItem.cantidadItem === 0 ||
                      +rowItem.puvItem === 0 ||
                      +rowItem.totalItem === 0
                    }
                    onClick={addRowItem}
                  >
                    <AddCircleOutlineOutlinedIcon />
                  </Fab>
                </Grid>
              </Grid>
            </Box>
          )}

          <Box sx={{ border: "1px solid LightGrey", p: 2, borderRadius: "5px" }}>
            <DataGrid
              rows={rowsItems}
              columns={tableColumns}
              {...tableOptions}
            />
          </Box>

          {pieFactura.cancelatoria && mostrarSubtotales && (
            <Box sx={{ width: "100%", mt: 2 }}>
              <Grid container spacing={1}>
                <Grid item xs={12} sm={12} md={6} lg={2}>
                  <TextField
                    sx={{ width: "100%" }}
                    inputProps={{ style: { textAlign: "center" } }}
                    id="subTotalItems"
                    label="Subtotal"
                    variant="outlined"
                    size="small"
                    name="subTotalItems"
                    value={pieFactura.subTotalItems.toLocaleString(
                      settings.numericLocales.language,
                      settings.numericLocales.options
                    )}
                    disabled
                  />
                </Grid>
                <Grid item xs={12} sm={12} md={6} lg={2}>
                  <TextField
                    sx={{ width: "100%" }}
                    inputProps={{ style: { textAlign: "center" } }}
                    id="totalDescuentos"
                    label="Descuentos"
                    variant="outlined"
                    size="small"
                    name="totalDescuentos"
                    value={pieFactura.totalDescuentos.toLocaleString(
                      settings.numericLocales.language,
                      settings.numericLocales.options
                    )}
                    disabled
                  />
                </Grid>
                <Grid item xs={12} sm={12} md={6} lg={2}>
                  <TextField
                    sx={{ width: "100%" }}
                    inputProps={{ style: { textAlign: "center" } }}
                    id="totalRecargos"
                    label="Recargos"
                    variant="outlined"
                    size="small"
                    name="totalRecargos"
                    value={pieFactura.totalRecargos.toLocaleString(
                      settings.numericLocales.language,
                      settings.numericLocales.options
                    )}
                    disabled
                  />
                </Grid>
                <Grid item xs={12} sm={12} md={6} lg={2}>
                  <TextField
                    sx={{ width: "100%" }}
                    inputProps={{ style: { textAlign: "center" } }}
                    id="totalCobrosACuenta"
                    label="Pagos a Cuenta (incluye Obras Sociales)"
                    variant="outlined"
                    size="small"
                    name="totalCobrosACuenta"
                    value={pieFactura.totalCobrosACuenta.toLocaleString(
                      settings.numericLocales.language,
                      settings.numericLocales.options
                    )}
                    disabled
                  />
                </Grid>
                <Grid item xs={12} sm={12} md={6} lg={2}>
                  <TextField
                    sx={{ width: "100%" }}
                    inputProps={{ style: { textAlign: "center" } }}
                    id="totalNoFacturable"
                    label="Canjes y Descuentos especiales"
                    variant="outlined"
                    size="small"
                    name="totalNoFacturable"
                    value={pieFactura.totalNoFacturable.toLocaleString(
                      settings.numericLocales.language,
                      settings.numericLocales.options
                    )}
                    disabled
                  />
                </Grid>
              </Grid>
            </Box>
          )}

          <Box sx={{ width: "100%", mt: 2 }}>
            <Grid container spacing={1}>
              <Grid item xs={12} sm={12} md={6} lg={2}>
                <TextField
                  sx={{ width: "100%" }}
                  inputProps={{ style: { textAlign: "center" } }}
                  id="subTotalFactura"
                  label="Subtotal"
                  variant="outlined"
                  size="small"
                  name="subTotalFactura"
                  value={pieFactura.subTotalFactura.toLocaleString(
                    settings.numericLocales.language,
                    settings.numericLocales.options
                  )}
                  disabled
                />
              </Grid>
              <Grid item xs={12} sm={12} md={6} lg={2}>
                <TextField
                  sx={{ width: "100%" }}
                  inputProps={{ style: { textAlign: "center" } }}
                  id="ivaFactura"
                  label="IVA"
                  variant="outlined"
                  size="small"
                  name="ivaFactura"
                  value={pieFactura.ivaFactura.toLocaleString(
                    settings.numericLocales.language,
                    settings.numericLocales.options
                  )}
                  disabled
                />
              </Grid>
              <Grid item xs={12} sm={12} md={6} lg={2}>
                <TextField
                  sx={{ width: "100%" }}
                  inputProps={{ style: { textAlign: "center" } }}
                  id="totalFactura"
                  label="Total"
                  variant="outlined"
                  size="small"
                  name="totalFactura"
                  value={pieFactura.totalFactura.toLocaleString(
                    settings.numericLocales.language,
                    settings.numericLocales.options
                  )}
                  disabled
                />
              </Grid>
            </Grid>

          </Box>
        </Box>

        <Button
          sx={{ m: 1 }}
          variant="contained"
          onClick={handleSave}
          startIcon={<SaveIcon />}
          disabled={disabledSaveCancelButtons}
        >
          Facturar Cobranza
        </Button>

        <Button
          sx={{ m: 1 }}
          variant="outlined"
          onClick={handleCancel}
          startIcon={<CancelIcon />}
          disabled={disabledSaveCancelButtons}
        >
          Cancelar
        </Button>
      </Paper>

      {/* >>>> Diálogo de búsqueda de Clientes */}

      {openDialogBuscarCliente && (
        <BuscarClienteDialog
          open={openDialogBuscarCliente}
          onClose={handleCloseDialogBuscarCliente}
          onSelect={handleSelectCliente}
          canCreateEdit={true}
        />
      )}

      {/* >>>> Diálogo de búsqueda de Personas Juridicas */}

      {openDialogBuscarPersonaJuridica && (
        <BuscarPersonaJuridicaDialog
          open={openDialogBuscarPersonaJuridica}
          onClose={handleCloseDialogBuscarPersonaJuridica}
          onSelect={handleSelectPersonaJuridica}
          canCreateEdit={true}
        />
      )}

      {showMessage && (
        <Message
          showMessage={showMessage}
          setShowMessage={setShowMessage}
          message={message}
        />
      )}

      <WaitingDialog open={isDoingSomething} />
    </>
  );
};
export default Factura;